import { useCallback } from "react";
import { StyleSheet } from "react-native";

import { BulletList, Timer } from "../components";
import { Button, Col, Col1, Content, Icon, TextBody, TextTitle } from "../lib";
import {
  formatDaysLeft,
  getDateFromServerTimestamp,
  getExpiresIn,
  openPath,
  useUser,
} from "../services";

const benefits = [
  "Can go online any time",
  "See client ratings",
  "See written reviews about you",
];

export function PremiumScreen() {
  // Data
  const { data: user } = useUser();

  // Vars
  const expiresIn =
    user?.premium && user.premium_expires_at
      ? formatDaysLeft(getDateFromServerTimestamp(user.premium_expires_at))
      : null;

  // Handlers
  const goToPurchase = useCallback(() => {
    openPath(`purchase/model?id=${user?.hash}`);
  }, [user?.hash]);

  // Render
  return (
    <Content>
      <Col1.C style={$.cover}>
        <Icon name="star-circle" large em={!!expiresIn} />
        <TextBody mt="2">
          {expiresIn
            ? "Your premium membership expires in:"
            : "You are not a premium member"}
        </TextBody>
        {!!expiresIn && <TextTitle>{expiresIn}</TextTitle>}
      </Col1.C>
      <Col1.T>
        <Col>
          <TextTitle mb="2">Premium account benefits</TextTitle>
          <Col ml="4">
            <BulletList content={benefits} icon="check" />
          </Col>
        </Col>
        {!!user?.offer && (
          <Col.C mt="8">
            <TextBody mb="4">{user.offer.promotion.name}</TextBody>
            <Timer
              value={getExpiresIn(
                getDateFromServerTimestamp(user.offer.expires_at),
                10,
              )}
            />
          </Col.C>
        )}
        {!user?.premium && (
          <Col mt="8">
            {user?.independent ? (
              <Button onPress={goToPurchase}>Buy premium now</Button>
            ) : (
              <TextBody>
                Please contact your agency your agency for a premium account
              </TextBody>
            )}
          </Col>
        )}
      </Col1.T>
    </Content>
  );
}

const $ = StyleSheet.create({
  cover: {
    maxHeight: 180,
  },
});
